import { v4 as uuid } from 'uuid';
import { TransportTypes } from '@/enums/TransportTypes';

export default class Transport {
  color = null
  countrySVG = null
  errorCountry = false
  errorCountryTrailer = false
  errorMarkModel = false
  errorType = false
  files = {}
  mark = null
  model = null
  number = null
  number_nationality_id = 182
  owner = null
  trailer = null
  trailer_nationality_id = 182
  trailerSVG = null
  type = TransportTypes.Auto
  uuid = uuid()
  number_missing = false
  drivers = []

  constructor(object) {
    Object.assign(this, object)
  }
}
